export enum SequenceTypes {
  ADD_BUDGETS = 'Budget/Bill/Proform',
  BUDGET = 'Budget',
  BILL = 'Bill',
  PROFORM = 'Proform',
  WAYBILLS = 'Waybills',
  CREDIT_NOTE = 'CreditNote',
}
